<template lang="pug">
GenericCard.goals-panel(size='75')
  .px-4.py-4
    .text-large เป้าหมายและค่าคอมมิชชั่น
    template(v-if='seller')
      .d-flex.px-3.pt-4
        img.rounded-circle(:src='seller.imgSrc' height='128' width='128')

        .detail.ml-4.pl-3
          .text-large {{ seller.name }}
          .d-flex.mt-2
            DataItem.mr-4( title='รหัส' :value='seller.id' )
            DataItem.ml-4( title='เขต' :value='seller.area ? seller.area.name : `-`' )
          .d-flex.mt-3
            DataItem.mr-4( title='email' :value='seller.email' )
            DataItem.ml-4( title='เบอร์ติดต่อ' :value='seller.telephone' )

  //- hr.m-0
  //- .d-flex.py-3.justify-content-center
  //-   ProfilePerformanceStatItem(
  //-     title='ค่าคอมมิชชั่น'
  //-     :value='this.daily.commission'
  //-     color='#E02020'
  //-     :iconSrc='require(`@/assets/icons/investment.svg`)'
  //-   )
  //-   ProfilePerformanceStatItem.ml-1(
  //-     title='ยอดขายวันนี้'
  //-     :value='this.daily.sales'
  //-     :iconSrc='require(`@/assets/icons/profits.svg`)'
  //-   )

  LoadedContentWrapper(
    :isLoading='isLoading'
    :data='goalDashboard.month'
    @reload='loadData'
  )
    .blue-gradient.px-4.py-4
      .text-large
        | เป้าหมายประจำเดือน

        template(v-if='goalDashboard.month')
          .d-flex.py-2.justify-content-center
            ProfilePerformanceStatItem(
              title='เป้าหมาย'
              :value='goalDashboard.month.goal'
              size='36'
              :iconSrc='require(`@/assets/icons/target.svg`)'
            )
            ProfilePerformanceStatItem.ml-1(
              title='ยอดขายที่ทำได้'
              size='30' color='#E02020'
              :value='goalDashboard.month.total_sale'
            )

      .px-4.mx-3
        template(v-if='goalDashboard.month')
          .progress.mt-3
            .progress-bar(
              :style='`width: ${progressPercentCalc}%`'
            )
          .d-flex.justify-content-between.mt-2
            .text-19.text-turquoise.font-weight-500
              | {{ (goalDashboard.month.total_sale) | currency }}
            .text-19.text-blue.font-weight-500
              | {{ (goalDashboard.month.goal) | currency }}

    hr.m-0

    .px-4.py-4
      .text-large สถิติการขาย
      template(v-if='goalDashboard.dynamic')
        .d-flex.py-2.justify-content-center
          ProfilePerformanceStatItem(
            title='ค่าคอมมิชชั่นสะสม'
            :value='goalDashboard.dynamic.total_commission'
            color='#E02020'
            :iconSrc='require(`@/assets/icons/investment.svg`)'
          )
          ProfilePerformanceStatItem.ml-1(
            title='ยอดขายสะสม'
            :value='goalDashboard.dynamic.total_sale'
            :iconSrc='require(`@/assets/icons/profits.svg`)'
          )
        .d-flex.py-2.px-3.justify-content-between
          //- NumberWithDescription(
          //-   :number='goalDashboard.dynamic.orders.total'
          //-   description='รายการขาย'
          //- )
          NumberWithDescription(
            :number='goalDashboard.dynamic.orders.back_orders'
            description='รายการ Back Order'
          )
          NumberWithDescription(
            :number='goalDashboard.dynamic.orders.cancelled'
            description='รายการยกเลิก'
          )

  VisitLog(:seller='seller')

  modal(
    name='goal-setter'
    width='400' height='600'
    transition='modal-transition'
  )
    GoalSetter(
      @closeButtonClicked='hideModal'
      @saveButtonClicked='hideModal'
    )

</template>

<script>
import ProfilePerformanceStatItem from '@/components/profile-performance/ProfilePerformanceStatItem.vue';
import GraphBestSellingProductGroup from '@/components/GraphBestSellingProductGroup.vue';
import CustomerShortDetailButton from '@/components/profile-performance/CustomerShortDetailButton.vue';

import GoalSetter from '@/components/_admin/seller-records/dialogs/GoalSetter.vue';

import VisitLog from './VisitLog.vue';

export default {
  props: {
    seller: {
      default: () => ({}),
    },
  },
  data: () => ({
    daily: {
      commission: 31670.00,
      sales: 55123.00,
    },
    filterDate: '',

    MOCK_CUSTOMER: {
      name: 'บริษัท ซาฟารีเวิลด์ จำกัด (มหาชน)',
      total: '3,1670.00',
    },

    // bestSellingsTableData: [],
    // bestSellingsTableColumns: {
    //   name: { title: 'ชื่อ', align: 'left' },
    //   total: { title: 'ยอดรวม', align: 'right' },
    // },

    // bestSellingsGroupRatio: [],

    // selectedProductGroup: [],
    // selectedProductGroupIndex: -1,

    goalDashboard: {},
    // goalDashboardStatic: {},

    isLoading: false,

    bestBuyers: [],
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // const resGoalDashboard = await this.$api.user.goalDashboard({ ...this.filterDate });
      const resGoalDashboard = await this.$api.admin.sellerRecords.goalDashboard(this.seller.id);
      if (resGoalDashboard.status === 200) {
        // if (Object.keys(this.goalDashboardStatic).length === 0) {
        //   this.goalDashboardStatic = resGoalDashboard.data; // initial only
        // }
        this.goalDashboard = resGoalDashboard.data;

        // this.bestSellingsTableData;
        // this.bestSellingsTableColumns;

        const byGroup = {};

        this.goalDashboard.best_sellers.forEach((elm) => {
          const strPad = `00${elm.group_id}`;
          const groupName = strPad.substring(strPad.length - 2, strPad.length);
          if (!(groupName in byGroup)) byGroup[groupName] = [];
          byGroup[groupName].push(elm);
        });

        console.log(byGroup);

        // const sorted = []; //

        const byGroupTable = [];

        Object.keys(byGroup).forEach((key) => {
          const obj = { group_id: key, name: key, total: 0 }; // TODO: find group name
          byGroup[key].forEach((elm) => {
            obj.name = elm.group_name;
            obj.total += parseFloat(elm.total);
          });
          byGroupTable.push(obj);
        });

        this.bestSellingsTableData = byGroupTable;

        // let wholeTotal = 0;
        // byGroupTable.forEach((elm) => { wholeTotal += elm.total; });

        this.bestSellingsGroupRatio = byGroupTable.map(elm => ({
          group: elm.group_id,
          value: elm.total,
        }));

        this.bestBuyers = [];
        this.goalDashboard.best_buyers.forEach((elm) => {
          this.bestBuyers.push({
            name: elm.customer_name,
            image: elm.avatar,
            grade: elm.grade,
            total: elm.total,
          });
        });

        this.isLoading = false;
      }
      // const res = await this.$api.user.bestSellingsList();
      // if (res.status === 200) {
      //   this.bestSellingsTableData = res.data.data;
      // }

      // const resProductGroup = await this.$api.user.bestSellingsGroupRatio();
      // if (res.status === 200) {
      //   this.bestSellingsGroupRatio = resProductGroup.data.data;
      // }
    },

    // bestSellingClicked(e) {
    //   this.selectedProductGroup = e.data;
    //   this.selectedProductGroupIndex = e.index;
    //   this.$modal.show('product-group-stat');
    // },

    setMonthlyGoal() {
      this.$modal.show('goal-setter');
    },
    hideModal() {
      this.$modal.hide('goal-setter');
    },
  },
  computed: {
    progressPercentCalc() {
      if (this.goalDashboard && this.goalDashboard.month) {
        const {
          total_sale: totalSale,
          goal,
        } = this.goalDashboard.month;

        if (goal === 0) { return 100; }

        const percentage = totalSale / goal * 100;
        return percentage < 100 ? percentage : 100;
      }
      return 0;
    },
  },
  components: {
    ProfilePerformanceStatItem,
    CustomerShortDetailButton,
    GraphBestSellingProductGroup,

    GoalSetter,
    VisitLog,
  },
};
</script>

<style lang="scss">
// .goals-panel {}
</style>
